import {prop, map, remove, clone, find, propEq} from 'ramda'

const getExtIds = map(prop('external_id'))

class addCrewCtrl {
  /* @ngInject */
  constructor (workforce, $mdDialog, Crews, crew, Auth) {
    this.workforce = clone(workforce)
    this.$mdDialog = $mdDialog
    this.selectedWorkers = []
    this.search
    this.auth = Auth

    if (crew) {
      let ids = getExtIds(crew.users)
      ids.forEach(this.findWorker.bind(this))
      this.crewName = crew.name
      this.crewId = crew.id
    }
  }

  findWorker (x) {
    const worker = find(propEq('external_id', x), this.workforce)
    if (worker) {
      worker.selected = true
      this.selectedWorkers.push(worker)
    }
  }

  cancel () {
    this.selectedWorkers = []
    this.$mdDialog.cancel()
  }

  addWorker (worker) {
    if (!worker.selected) this.selectedWorkers.push(worker)
    worker.selected = true
  }

  removeWorker (index) {
    this.selectedWorkers[index].selected = false
    this.selectedWorkers = remove(index, 1, this.selectedWorkers)
  }

  saveCrew () {
    this.$mdDialog.hide({
      name: this.crewName,
      users: getExtIds(this.selectedWorkers),
      id: this.crewId,
      legacyInternalId: this.auth.me.internalId
    })
  }
}

export default addCrewCtrl
